import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import ForcePasswordChange from "./ForcePasswordChange";

export default function ProtectedRoute({ roles }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-3" data-testid="auth-loading">
          <div className="h-10 w-10 rounded-full border-2 border-amber-500/30 border-t-amber-500 animate-spin" />
          <p className="text-sm text-slate-400 font-mono">Caricamento…</p>
        </div>
      </div>
    );
  }

  if (user === false) return <Navigate to="/login" replace />;

  if (user && user.must_change_password) return <ForcePasswordChange />;

  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
